import axios from 'axios';
import {config} from '../config/index.ts';
import {
  ApiResponse,
  DeleteApiParams,
  GetApiParams,
  PostApiParams,
  PutApiParams,
} from '../types/apiParams.ts';

export const baseURL =
  process.env.NODE_ENV === 'production'
    ? config.backend.prodBaseURL
    : config.backend.devBaseURL;
const apiPath = config.backend.apiPath;

const errHandler = async (promise: Promise<ApiResponse>) => {
  try {
    const {data} = await promise;

    return {data, err: null};
  } catch (error: any) {
    if (!error.response) {
      return {data: null, err: error.message};
    }
    return {data: null, err: error?.response?.data.error};
  }
};

const api = {
  delete: ({params = {}, url}: DeleteApiParams) => {
    return errHandler(
      axios.delete(url, {
        params,
      }),
    );
  },

  get: ({headers = {}, params = {}, url}: GetApiParams) => {
    return errHandler(
      axios.get(url, {
        headers,
        params,
      }),
    );
  },

  init: async () => {
    axios.defaults.baseURL = baseURL + apiPath;
    axios.defaults.headers.common['Content-Type'] = 'application/json';
    axios.defaults.headers.common['Accept'] = 'application/json';
  },

  post: ({data = null, headers = {}, url}: PostApiParams) => {
    return errHandler(
      axios.post(url, data, {
        headers,
      }),
    );
  },

  put: ({data = null, url}: PutApiParams) => {
    return errHandler(axios.put(url, data));
  },
};

export default api;
